import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, fmtDate, fmtEUR, SERVICE_TYPE_LABEL, getToken, API_BASE } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Badge } from "../components/ui/badge";
import { ArrowLeft, Plus, Trash2, FileDown } from "lucide-react";
import PageHeader from "../components/PageHeader";

export default function ServicoDetalhe() {
  const { id } = useParams();
  const [s, setS] = useState(null);
  const [entry, setEntry] = useState({ description: "", hours: "", work_date: new Date().toISOString().slice(0, 10) });

  const load = () => api.get(`/services/${id}`).then(r => setS(r.data));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [id]);

  const addEntry = async () => {
    if (!entry.description || !entry.hours) return toast.error("Preencha descrição e horas");
    try {
      await api.post(`/services/${id}/work-entries`, { ...entry, hours: parseFloat(entry.hours) });
      setEntry({ description: "", hours: "", work_date: new Date().toISOString().slice(0, 10) });
      toast.success("Registo adicionado"); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Erro"); }
  };

  const delEntry = async (eid) => {
    await api.delete(`/services/${id}/work-entries/${eid}`); toast.success("Removido"); load();
  };

  if (!s) return <p data-testid="servico-loading">A carregar...</p>;

  const totalHours = (s.work_entries || []).reduce((a, b) => a + Number(b.hours || 0), 0);
  const reportUrl = `${API_BASE}/services/${id}/work-report.pdf?token=${getToken()}`;

  return (
    <div data-testid="servico-detalhe-page">
      <Link to="/servicos" className="text-sm text-slate-500 inline-flex items-center gap-1 mb-2 hover:text-slate-800" data-testid="back-servicos"><ArrowLeft size={14} /> Voltar a Serviços</Link>
      <PageHeader title={s.description} subtitle={`${SERVICE_TYPE_LABEL[s.type]} · Cliente: ${s.client_name}`} testid="servico-detalhe-header" />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        <div className="a4w-card p-4"><p className="a4w-label">Valor</p><p className="text-xl font-semibold">{fmtEUR(s.amount)}</p></div>
        <div className="a4w-card p-4"><p className="a4w-label">Início</p><p className="text-xl font-semibold">{fmtDate(s.start_date)}</p></div>
        <div className="a4w-card p-4"><p className="a4w-label">Expiração</p><p className="text-xl font-semibold">{s.expires_at ? fmtDate(s.expires_at) : "—"}</p></div>
        <div className="a4w-card p-4"><p className="a4w-label">Faturação</p><p className="text-xl font-semibold">{s.billing === "yearly" ? "Anual" : "Única"}</p></div>
      </div>

      {s.type === "prestacao" && (
        <div className="a4w-card p-6" data-testid="work-entries-section">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold">Registo de Horas <Badge variant="outline" className="ml-2">Total: {totalHours.toFixed(2)} h</Badge></h3>
            <a href={reportUrl} target="_blank" rel="noreferrer" data-testid="download-work-report">
              <Button variant="outline"><FileDown size={16} /> Gerar PDF Relatório</Button>
            </a>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-12 gap-3 mb-4">
            <div className="md:col-span-2"><Label>Data</Label><Input type="date" value={entry.work_date} onChange={(e) => setEntry({ ...entry, work_date: e.target.value })} data-testid="entry-date" /></div>
            <div className="md:col-span-7"><Label>Descrição</Label><Input value={entry.description} onChange={(e) => setEntry({ ...entry, description: e.target.value })} data-testid="entry-desc" placeholder="Trabalho realizado..." /></div>
            <div className="md:col-span-2"><Label>Horas</Label><Input type="number" step="0.25" value={entry.hours} onChange={(e) => setEntry({ ...entry, hours: e.target.value })} data-testid="entry-hours" /></div>
            <div className="md:col-span-1 flex items-end"><Button onClick={addEntry} className="bg-[#1E3A8A] hover:bg-[#172554] w-full" data-testid="entry-add"><Plus size={16} /></Button></div>
          </div>

          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-left">
              <tr>
                <th className="px-3 py-2 a4w-label">Data</th>
                <th className="px-3 py-2 a4w-label">Descrição</th>
                <th className="px-3 py-2 a4w-label text-right">Horas</th>
                <th className="px-3 py-2"></th>
              </tr>
            </thead>
            <tbody>
              {(s.work_entries || []).map(e => (
                <tr key={e.id} className="border-t border-slate-100">
                  <td className="px-3 py-2">{fmtDate(e.work_date)}</td>
                  <td className="px-3 py-2">{e.description}</td>
                  <td className="px-3 py-2 text-right font-mono">{Number(e.hours).toFixed(2)}</td>
                  <td className="px-3 py-2 text-right"><Button size="icon" variant="ghost" onClick={() => delEntry(e.id)} data-testid={`del-entry-${e.id}`}><Trash2 size={16} className="text-red-600" /></Button></td>
                </tr>
              ))}
              {(s.work_entries || []).length === 0 && (
                <tr><td colSpan="4" className="px-3 py-8 text-center text-slate-500">Sem registos ainda.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
